export default __webpack_public_path__ + "static/media/temperatuurKlein.95fe39e8.jpg";